import dictionary from "@/services/dictionary";
import $ from "jquery";
import helper from "@/services/helper";
import ajax from "@/services/ajax";
import tippy from "tippy.js";

export default {
  data() {
    return {
      item: {},
      error: null,
      success: null,
      loading: false,
      sending: false,
    };
  },
  computed: {
    action() {
      if (this.item && this.shortcut) {
        return "/hr/recruits/" + this.shortcut;
      } else {
        return "";
      }
    },
    twoCompanies() {
      if (this.item && this.item.companies) {
        return (
          (this.item.companies.indexOf(3) >= 0 ||
            this.item.companies.indexOf(6) >= 0) &&
          (this.item.companies.indexOf(1) >= 0 ||
            this.item.companies.indexOf(5) >= 0 ||
            this.item.companies.indexOf(4) >= 0)
        );
      }
      return false;
    },
    isBusiness() {
      if (this.item && this.item.companies) {
        return (
          this.item.companies.indexOf(3) >= 0 ||
          this.item.companies.indexOf(6) >= 0
        );
      }
      return false;
    },
    isGroup() {
      if (this.item && this.item.companies) {
        return (
          this.item.companies.indexOf(1) >= 0 ||
          this.item.companies.indexOf(5) >= 0 ||
          this.item.companies.indexOf(4) >= 0
        );
      }
      return false;
    },
  },
  mounted() {
    this.setItem();
    this.hookForms();
  },
  methods: {
    hookForms() {
      let self = this;
      this.$nextTick(function () {
        self.loading = false;
        helper.maskPostal();
        helper.datepicker();
        helper.maskIdNumber();
        tippy("[data-tippy-content]");
        $(".recruitmentForm").each(function () {
          ajax.postValidate(
            $(this),
            self,
            function (form, vm, data) {
              self.sending = false;
              self.$emit("forward", data);
            },
            function (data) {
              self.error = data.message;
              self.sending = false;
              $("html,body").animate(
                { scrollTop: $(document).height() },
                "slow"
              );
            },
            function () {
              self.error = null;
              self.sending = true;
            }
          );
        });
      });
    },
    refreshForm() {
      this.$forceUpdate();
    },
    scrollToAnchor(aid) {
      let aTag = $("#" + aid);
      if (typeof aTag !== "undefined" && typeof aTag.offset() !== "undefined") {
        $("html,body").animate({ scrollTop: aTag.offset().top - 160 }, "slow");
      }
    },
    setItem() {
      if (this.data && this.data.uid) {
        this.item = this.data;
      } else {
        this.item = {
          data: {},
        };
      }
    },
  },
  watch: {
    data() {
      this.setItem();
    },
    $route() {
      this.hookForms();
    },
    step() {
      this.hookForms();
      this.$nextTick(() => {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        tippy("[data-tippy-content]");
      });
    },
  },
  mixins: [dictionary],
  props: ["data", "shortcut", "step"],
};
